function generateDefaultInitialStaticPageState() {
  return {
    staticPage: null,
  };
}

function staticPageReducer(state = generateDefaultInitialStaticPageState(), action) {
  let newState;

  switch (action.type) {
    case 'GET_STATIC_PAGE_INFO_FULFILLED': {
      const responseData = action.payload.response.data.data;
      newState = {
        ...state,
        staticPage: responseData,
      };
      break;
    }

    case 'RESET_STATIC_PAGE_DETAIL': {
      newState = {
        ...state,
        staticPage: null,
      };

      break;
    }

    case 'SET_REWRITE_URL': {
      newState = {
        ...state,
        rewriteUrl: action.payload,
      };
      break;
    }


    case 'LEAVE_HOME_PAGE_ROUTE':
    case 'LEAVE_TAG_PAGE_ROUTE':
    case 'LEAVE_BRAND_CATEGORY_PAGE_ROUTE':
    case 'LEAVE_SEARCH_PAGE_ROUTE':
    case 'LEAVE_CATEGORY_PAGE_ROUTE':
    case 'LEAVE_CAMPAIGN_PAGE_ROUTE':
    case 'LEAVE_DYNAMIC_PAGE_ROUTE':
    case 'LEAVE_STATIC_PAGE_ROUTE':
    case 'LEAVE_BRAND_PAGE_ROUTE':
    case 'LEAVE_AUTHORS_PAGE_ROUTE': {
      newState = {
        ...state,
        staticPage: null,
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default staticPageReducer;
export {generateDefaultInitialStaticPageState};
